import React from 'react'
import { Link } from 'react-router-dom';
import Footerlogo from '../../assets/images/logo2.png';
import India from '../../assets/images/india.png'
import Usa from '../../assets/images/usa.png'
import Canada from '../../assets/images/canada.png'
import { FaXTwitter } from "react-icons/fa6";


const Footer = () => {
    return (
        <footer className="footer-one" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
            <div className="container" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                <div className="footer-main-one" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                    <div className="footer-one-inner pt-5" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                        <div className="row gutter-y-30" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                            <div className="col-xl-3 col-lg-4 col-md-6 footer-about" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                                <div className="footer-one-about" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                                    {/* <Link to="#">
                                        <img src={Footerlogo} alt="footer-logo" />
                                    </Link> */}
                                </div>
                                <div className="footer-one-about-details pb-0 mb-0" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                                    <p id='footer-description'>
                                    The NRI Advisors is your trusted partner in investment, real estate, legal, and financial solutions, dedicated exclusively to serving global NRIs.
                                    </p>
                                </div>
                                <div className="footer-one-about-contact" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                                    <h4 style={{marginTop: "-26px"}} >Contact us</h4>
                                    <ul >
                                        <li >
                                            <Link to="mailto:support@thenriadvisors.com">
                                                <i className="flaticon-envelope" />
                                                support@thenriadvisors.com
                                            </Link>
                                        </li>
                                        <li >
                                            <Link to="tel:+91 9851295129">
                                            <img src={India} style={{width: "28px", marginLeft: "2px",}}/>
                                                +91 9851295129
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="tel:+1 732-734-2800">
                                            <img src={Usa} style={{width: "28px", marginLeft: "2px",}}/>
                                                +1 732-734-2800
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="tel:+1 647-323-7523">
                                            <img src={Canada} style={{width: "28px", marginLeft: "2px",}}/>
                                                +1 647-323-7523
                                            </Link>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                        
                            <div className="col-xl-3 col-lg-4 col-md-6 partition " style={{backgroundImage : 'none', backgroundColor: "#041021fa" ,}}>
                                <div className="footer-one-link" style={{backgroundImage : 'none', backgroundColor: "#041021fa"}}>
                                    <h3>Services</h3>
                                    <ul className="footer-services-list">
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/execution-of-wills">Execution of Wills</Link>
                                        </li>
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/real-estate-management">Real Estate Management</Link>
                                        </li>
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/legal">Legal</Link>
                                        </li>
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/documentation">Documentation</Link>
                                        </li>                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                            <i className="flaticon-right-arrow" />
                            <Link to="/finance-and-accountancy">Finance and Accountancy</Link>
                        </li>
                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                            <i className="flaticon-right-arrow" />
                            <Link to="/taxation">Taxation</Link>
                        </li>
                       {/*<li>
                            <i className="flaticon-right-arrow" />
                            <Link to="/medical-services">Medical Services</Link>
                        </li>*/}
                    
                       {/* <li>
                            <i className="flaticon-right-arrow" />   
                            <Link to="/immigration">Immigration</Link>
                        </li>*/}{/*
                       {/* <li>
                            <i className="flaticon-right-arrow" />
                            <Link to="/events-and-entertainment">Events & Entertainment</Link>
                        </li>*/}
                       {/* <li>
                            <i className="flaticon-right-arrow" />
                            <Link to="/security">Security</Link>
                        </li>*/}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-6">
                                <div className="footer-one-link m-0" >
                                    <h3>Pages</h3>
                                    <ul className="footer-pages-list">
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/why-choose-us">Why Choose Us?</Link>
                                        </li>
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/about-us">About</Link>
                                        </li>
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/contact-us">Contact Us</Link>
                                        </li>
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/resources">Resources</Link>
                                        </li>
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/blog">Blog</Link>
                                        </li>
                                        <li style={{whiteSpace: 'nowrap', fontSize: '14px'}}>
                                            <i className="flaticon-right-arrow" />
                                            <Link to="/testimonials">Testimonials</Link>
                                        </li>
                                      
                                    
                                    </ul>
                                </div>
                            </div>
                              
                            <div className="col-xl-4 col-md-6 ">
                                <div className="footer-One-subscribe">
                                    <h3>Subscribe</h3>
                                    <p>
                                        Stay Up-to the date with latest trends and news related to NRIs by subscribing to our newsletter. 
                                    </p>
                                    <form className="footer-One-subscribe-form" action="#">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Your Email Address"
                                            required=""
                                        />
                                        <button type="submit" className="btn btn-primary btn-small ">
                                            Subscribe <i className="flaticon-next" />
                                        </button>
                                    </form>
                                    <div className="footer-one-social-media">
                                        <h4>Let's Connect</h4>
                                        <ul>
                                            <li>
                                                <Link to="https://www.facebook.com/people/The-NRI-Advisors/61564183366143/?mibextid=ZbWKwL" target="_blank">
                                                    <i className="fa-brands fa-facebook-f" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="https://www.instagram.com/the_nri_advisors/?igsh=andicTU5ZnVwbWNs#" target="_blank">
                                                    <i className="fa-brands fa-instagram" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="https://www.linkedin.com/company/the-nri-advisors/" target="_blank">
                                                    <i className="fa-brands fa-linkedin-in" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="https://x.com/NriAdvisors" target="_blank">
                                                    <FaXTwitter />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid p-0 mt-0 pt-0">
                <div className="footer-lower">
                    <div className="container">
                        <div className="row row-gap-3">
                            <div className="col-md-6">
                                <div className="footer-copy-right-one">
                                    <p>Copyright © 2026 The NRI Advisors, All Rights Reserved</p>
                                </div>
                            </div>
                            <div className="col-md-6 text-center">
                                <div className="footer-buttom-link text-end">
                                    <ul>
                                        <li>
                                            <a href="/the-nri-advisors-privacy-policy.pdf" target="_blank" rel="noopener noreferrer">
                                                Terms &amp; Conditions &nbsp; and &nbsp; Privacy Policy
                                            </a>
                                        </li>

                                        {/* <li>
                                            <Link to="/privacy-policy">Privacy policy</Link>
                                        </li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default Footer;